import React from 'react';
import { Table, Button, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import styles from './Banks.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import withMosadIsolation from '../../utils/withMosadIsolation';
import { fetchBanks, setLoading, setError } from '../../redux/slices/banksSlice';
import { t } from '../../i18n';

const Banks = () => {
  // const { mosadData, mosadToken } = useSelector((state) => state.user); 
  // const selectedMosadCode = useSelector((state) => state.user.selectedMosadCode)
  const { banks, loading, error } = useSelector((state) => state.banks);
  const dispatch = useDispatch();

  useEffect(() => {
      try {
        dispatch(fetchBanks());
        dispatch(setLoading(false));
      } catch (err) {
        dispatch(setError(err.message || t('ui.banks.fetchFailed')));
        dispatch(setLoading(false));
      }
  }, [dispatch]);

  if (loading) {
    return <div>{t('ui.banks.loading')}</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }
  
  return (
    <Container fluid>
      <div className={styles.header}>
        <h2>{t('ui.banks.title')}</h2>
        <Button as={Link} to="/banks/new" variant="primary">
          <FaPlus className="me-2" />
          {t('ui.banks.newBank')}
        </Button>
      </div>

      <Table responsive hover className={styles.table}>
        <thead>
          <tr>
            <th>{t('ui.banks.bankCode')}</th>
            <th>{t('ui.banks.bankName')}</th>
            <th>{t('ui.banks.actions')}</th>
          </tr>
        </thead>
        <tbody>
          {banks.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center">
                {t('ui.banks.noBanks')}
              </td>
            </tr>
          ) : (
            banks.map(bank => (
              <tr key={bank.code}>
                <td>{bank.code}</td>
                <td>{bank.name}</td>
                <td>
                  <Button
                    as={Link}
                    to={`/banks/${bank.code}`}
                    variant="outline-primary"
                    size="sm"
                    className="me-2"
                  >
                    <FaEdit />
                  </Button>
                  <Button variant="outline-danger" size="sm">
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </Container>
  );
};

export default withMosadIsolation(Banks); 